import _ from "lodash";
import { IEventsTranslation } from "../domain/models/EventsTranslation";
import { SimpleMapper } from "./SimpleMapper";
import { EventsTranslationDTO } from "../domain/models/dto/EventsDTO";

export class EventsTranslationMapper extends SimpleMapper<
    IEventsTranslation,
    EventsTranslationDTO
> {
    protected toDTOFields: string[] = [
        "id",
        "title",
        "subtitle",
        "description",
        "languageCode",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "eventId",
        "availableLangs",
    ];

    fromDTO(dto: EventsTranslationDTO): IEventsTranslation {
        if (!dto) {
            return null;
        }
        const result = super.fromDTO(dto);
        result.languageCode = !_.isEmpty(dto.languageCode)
            ? result.languageCode.toLowerCase()
            : null;

        return result;
    }

    toDTO(model: IEventsTranslation): EventsTranslationDTO {
        if (!model) {
            return null;
        }
        const result = super.toDTO(model);
        result.languageCode = !_.isEmpty(model.languageCode)
            ? result.languageCode.toLowerCase()
            : null;

        return result;
    }
}
